export default function bcycleAvailablePopup(data) {
	return `<p>
	<span>${data.num_bikes_available}</span>
	bikes &nbsp; &nbsp;
	<span>${data.num_docks_available}</span>
	docks
</p>`;
}
